import cn from 'classnames';
import { Notifications } from '#components/patterns/notifications/Notifications.tsx';
import { useNotifications } from '#global/context/notifications/useNotifications.tsx';
import { PageHeader } from '../../page-header/PageHeader.tsx';
import styles from './TableLayout.module.css';

type Props = {
  header: React.ReactElement | string;
  children?: React.ReactNode;
  isEmpty?: boolean;
  pagination?: React.ReactNode;
  headerClass?: string;
};

export function TableLayout({ header, isEmpty, children, pagination, headerClass }: Props) {
  const headerElement = typeof header === 'string' ? <PageHeader title={header} /> : header;
  // Technically, <Notifications/> pulls this itself, but we want to know whether there are any,
  // so we can set a class name or not
  const { notifications } = useNotifications();
  return (
    <div
      className={cn(styles.TableLayout, {
        [styles.TableLayout___empty]: isEmpty,
      })}
    >
      <div className={cn({ [styles.TableLayout_notifications]: notifications.length })}>
        <Notifications />
      </div>
      <div className={cn(headerClass, styles.TableLayout_header)}>{headerElement}</div>
      <div className={styles.TableLayout_body}>
        <div className={styles.TableLayout_bodyTableWrapper}>{children}</div>
      </div>
      {Boolean(pagination) && <div className={styles.TableLayout_footer}>{pagination}</div>}
    </div>
  );
}
